(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baroona-brand-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = [...document.querySelectorAll('[data-brand-directory]')];
    if (!sections.length) return;

    const cards = [...document.querySelectorAll('[data-brand-card]')];
    const search = document.querySelector('[data-brand-search]');
    const letterButtons = [...document.querySelectorAll('[data-brand-letter]')];
    const emptyMessages = [...document.querySelectorAll('[data-brand-empty]')];
    let selectedLetter = 'all';

    const filterCards = () => {
      const term = (search?.value || '').trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const matchesText = !term || card.dataset.brandName.includes(term);
        const matchesLetter = selectedLetter === 'all' || card.dataset.brandLetterValue === selectedLetter;
        const show = matchesText && matchesLetter;
        card.hidden = !show;
        if (show) visible += 1;
      });
      emptyMessages.forEach((message) => { message.hidden = visible !== 0; });
    };

    search?.addEventListener('input', filterCards);
    letterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        selectedLetter = button.dataset.brandLetter;
        letterButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        filterCards();
        sections[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["baroona-home-launch-additions"] && !Shopify.designMode) return;
  try {
    
(() => {
  const shuffle = a => {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };
  document.querySelectorAll('[data-bha-brands]').forEach(grid => {
    const reveal = () => {
      const cards = shuffle(Array.from(grid.querySelectorAll('[data-bha-brand]')).filter(c => !c.classList.contains('is-broken')));
      grid.querySelectorAll('[data-bha-brand]').forEach(c => c.classList.remove('is-visible'));
      cards.slice(0, 8).forEach(c => c.classList.add('is-visible'));
    };
    reveal();
    setTimeout(reveal, 700);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["baroona-home-v9-market"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bhw-discovery').forEach((section) => {
    const slots = Array.from(section.querySelectorAll('.bhw-discovery-slot'));
    const button = section.querySelector('.bhw-discovery-refresh');

    const chooseProducts = () => {
      slots.forEach((slot) => {
        const candidates = Array.from(slot.querySelectorAll('template.bhw-discovery-candidate'));
        const display = slot.querySelector('.bhw-discovery-display');
        if (!display || candidates.length === 0) return;

        const previous = Number(slot.dataset.candidateIndex || -1);
        let next = Math.floor(Math.random() * candidates.length);
        if (candidates.length > 1 && next === previous) next = (next + 1) % candidates.length;
        slot.dataset.candidateIndex = String(next);
        display.replaceChildren(candidates[next].content.cloneNode(true));
      });
    };

    chooseProducts();
    button?.addEventListener('click', () => {
      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.startViewTransition(chooseProducts);
      } else {
        chooseProducts();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
